import { render, staticRenderFns } from "./EzAccountMenu.vue?vue&type=template&id=b956f072&scoped=true&"
import script from "./EzAccountMenu.vue?vue&type=script&lang=js&"
export * from "./EzAccountMenu.vue?vue&type=script&lang=js&"
import style0 from "./EzAccountMenu.vue?vue&type=style&index=0&id=b956f072&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b956f072",
  null
  
)

export default component.exports